<template>
	<div v-if="isUserAllowedInLevel5or6">
		<BaseHeader :title="$t('edit_customer').toString()" />

		<div class="main mb-14">
			<div v-if="!isLoading">
				<CustomerForm ref="CustomerForm" @updateValue="customer = $event" :start-value="customer" />
				<BaseSelect
					required="true"
					:label="$t('customer_consultant')"
					:options="consultants"
					v-model="selectedConsultant"
					ref="BaseSelect-Title"
					:allow-empty="true"
					class="w-1/2 md:pr-2"
				/>
			</div>
		</div>

		<Footer @backButtonClick="goBack" :is-continue-button="false" :is-skippable="false" :is-back-button="true" class="m-8">
			<template #right>
				<BaseButton @click="save()" class="btn-blue">{{ $t('general.save') }}</BaseButton>
			</template>
		</Footer>
	</div>
	<Forbidden v-else />
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import CustomerForm from '@/components/forms/CustomerForm';
import BaseButton from '@/components/forms/buttons/BaseButton';
import { CompanyApiFactory, CustomersApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import Footer from '@/components/damagecases/Footer';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';
export default {
	name: 'CustomerEdit',
	components: { Forbidden, Footer, BaseButton, CustomerForm, BaseHeader, BaseSelect },
	mixins: [Authentication],
	data() {
		return {
			customer: {},
			consultants: [],
			selectedConsultant: {},
			isLoading: true,
		};
	},
	created() {
		if (this.isUserAllowedInLevel5or6) {
			this.isLoading = true;
			if (this.$route.params.customer) {
				CustomersApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.customersIdGet(this.$route.params.customer)
					.then(response => {
						this.customer = response.data;
					})
					.finally(_ => {
						this.getConsultants();
					});
			}
		}
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		getConsultants() {
			CompanyApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.getconsultantsGet()
				.then(response => {
					response.data.map(option => {
						option.value = option.id;
						option.display = option.firstName + ' ' + option.lastName;

						if (this.customer.consultant != null) {
							if (option.value === this.customer.consultant.id) {
								this.selectedConsultant = option;
							}
						}

						this.consultants.push(option);
					});
				})
				.finally(_ => {
					this.isLoading = false;
				});
		},
		save() {
			if (this.$refs.CustomerForm.validate()) {
				this.customer.consultant = this.selectedConsultant;
				CustomersApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.customersIdPut(this.$route.params.customer, this.customer)
					.then(response => {
						if (response.data.id) {
							this.$store.commit('setConfirmLeaving', false);
							this.$swal({
								title: this.$t('general.success').toString(),
								text: this.$t('customer_saved_successfully').toString(),
								icon: 'success',
							}).then(result => {
								this.$router.push({ name: 'management.customer.overview', params: { customer: this.$route.params.customer } });
							});
						} else {
							this.$swal(this.$t('general.attention').toString(), this.$t('error_saving').toString(), 'warning');
						}
					})
					.catch(error => {
						this.isSearchRunning = false;
					});
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
};
</script>

<style scoped></style>
